import React from 'react'
import './TitelSection.css'
export default function TitelSection({ title }) {
    return (
        <h1 className='TitelSection'>
            {title}
        </h1>
    )
}
